<h2 style="font-weight: bold; margin-bottom: 0px">
  Seja bem-vindo ao Sistema Oráculo!
</h2>
<iframe src="https://player.vimeo.com/video/546650796" width="100%" height="70%" 
frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>

<button style="float: right" mat-raised-button color="secondary" (click)="onNoClick()">
  Fechar
</button>